import { Pencil, Trash2, HardHat, Wallet, MapPin, ListChecks } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { euro } from "@/lib/format";

const Num = ({ label, value, strong, testid }) => (
  <div className="rounded-lg bg-secondary/50 px-2.5 py-2 min-w-0">
    <div className="text-[11px] uppercase tracking-wider font-semibold text-muted-foreground truncate">{label}</div>
    <div className={`font-heading tabular-nums truncate ${strong ? "text-lg font-extrabold text-primary" : "text-base font-bold"}`} data-testid={testid}>{value}</div>
  </div>
);

// Scheda operaio: ore fatte e dove, quanto ha maturato, anticipi dati e quanto resta da pagare.
export const OperaioCard = ({ o, s, onEdit, onDelete, onToggle, onMovimenti, onRiepilogo, mese }) => {
  const r = s || { ore: 0, maturato: 0, anticipi: 0, rimborsi: 0, da_pagare: 0, da_pagare_totale: 0, cantieri: [] };
  return (
    <div className={`rounded-xl border border-border bg-card p-4 space-y-3 ${o.attivo === false ? "opacity-60" : ""}`} data-testid={`operaio-row-${o.id}`}>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-orange-100 text-orange-700 dark:bg-orange-950/50 dark:text-orange-300 flex items-center justify-center shrink-0"><HardHat className="w-5 h-5" /></div>
        <div className="flex-1 min-w-0">
          <div className="font-heading font-bold truncate">{o.nome}</div>
          <div className="text-sm text-muted-foreground truncate">{[o.mansione, o.telefono, `${euro(o.costo_orario)}/h`].filter(Boolean).join(" · ")}</div>
        </div>
        <Switch checked={o.attivo !== false} onCheckedChange={(v) => onToggle(o, v)} aria-label="Attivo" data-testid={`operaio-toggle-${o.id}`} />
        <Button variant="ghost" size="icon" onClick={() => onEdit(o)} aria-label="Modifica" data-testid={`operaio-edit-${o.id}`}><Pencil className="w-4 h-4" /></Button>
        <Button variant="ghost" size="icon" className="hover:text-destructive" onClick={() => onDelete(o)} aria-label="Elimina" data-testid={`operaio-delete-${o.id}`}><Trash2 className="w-4 h-4" /></Button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        <Num label={mese ? "Ore del mese" : "Ore fatte"} value={`${r.ore.toLocaleString("it-IT")} h`} testid={`operaio-hours-${o.id}`} />
        <Num label={mese ? "Maturato nel mese" : "Maturato"} value={euro(r.maturato)} testid={`operaio-earned-${o.id}`} />
        <Num label={mese ? "Anticipi del mese" : "Anticipi dati"} value={euro(r.anticipi)} testid={`operaio-advances-${o.id}`} />
        <Num label="Da pagare in tutto" value={euro(r.da_pagare_totale ?? r.da_pagare)} strong testid={`operaio-due-${o.id}`} />
      </div>
      {r.rimborsi > 0 && <div className="text-xs text-muted-foreground">Compresi {euro(r.rimborsi)} di rimborsi spese.</div>}
      <div className="space-y-1.5" data-testid={`operaio-sites-${o.id}`}>
        <div className="text-xs font-semibold text-muted-foreground flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> Dove ha lavorato</div>
        {r.cantieri.length ? (
          <div className="flex flex-wrap gap-1.5">
            {r.cantieri.map((c) => (
              <span key={c.cantiere_id} className="rounded-full border border-orange-200 bg-orange-50 dark:bg-orange-950/30 dark:border-orange-900 px-3 py-1 text-sm" data-testid={`operaio-site-${o.id}-${c.cantiere_id}`}>
                {c.nome} · <b>{c.ore.toLocaleString("it-IT")} h</b>
              </span>
            ))}
          </div>
        ) : <div className="text-sm text-muted-foreground">{mese ? "Nessuna ora registrata in questo mese." : "Nessuna ora registrata finora."}</div>}
      </div>
      <div className="grid grid-cols-2 sm:flex gap-2">
        <Button variant="outline" onClick={() => onRiepilogo(o)} data-testid={`operaio-riepilogo-${o.id}`}>
          <ListChecks className="w-4 h-4 mr-1.5" /> Riepilogo
        </Button>
        <Button variant="outline" onClick={() => onMovimenti(o)} data-testid={`operaio-movimenti-${o.id}`}>
          <Wallet className="w-4 h-4 mr-1.5" /> Anticipi e rimborsi
        </Button>
      </div>
    </div>
  );
};

export default OperaioCard;
